import React, { useEffect, useState } from "react";
import "./styles.scss";
import { useTranslation } from "react-i18next";
import { FaFacebookF, FaYoutube, FaInstagram, FaChevronUp } from 'react-icons/fa';
import axios from '../../api/axiosService';

function Footer(props) {
  const { t } = useTranslation();
  const [isVisibleGoToTop, setIsVisibleGoToTop] = useState(false);
  const [link_infos, setLinkInfos] = useState('')
  

  const getLinkShoppe = async () => {
    try {
      const response = await axios.get("/api/setting/info");
      setLinkInfos(response.data.data)
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  useEffect(() => {
    getLinkShoppe()
    const toggleVisibility = () => {
      setIsVisibleGoToTop(window.scrollY > 100);
    };

    window.addEventListener("scroll", toggleVisibility);

    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="footer-ssg">
      <button className={`scroll-to-top-btn ${isVisibleGoToTop ? "show" : ""}`} onClick={scrollToTop}>
        <FaChevronUp className="icon" />
        <span className="label">TOP</span>
      </button>
      <div className="title">
        <span>{t("home.footer.footer_text_1")}&nbsp;</span>
        <span>{t("home.footer.footer_text_2")}</span>
      </div>
      <div className="tvo-credit" style={{cursor: "pointer"}}>
        <a href={link_infos.facebook_link} target="_blank" rel="noopener noreferrer" style={{marginLeft: '20px', marginRight: '16px'}}>
          <FaFacebookF />
        </a>
        <a href={link_infos.youtube_link} target="_blank" rel="noopener noreferrer" style={{marginRight: '16px'}}>
          <FaYoutube />
        </a>
        <a href={link_infos.instagram_link} target="_blank" rel="noopener noreferrer">
          <FaInstagram />
        </a>
      </div>
    </div>
  );
}

export default Footer;
